<!-- src/components/Inventario/Reportes/ScrapAlmacenLaser/components/SALPanelResumen.vue -->
<template>
  <aside class="sal-panel">
    <h3 class="sal-panel__titulo">
      Análisis de desperdicio
      <span class="sal-panel__subtitulo">Almacén y Láser</span>
    </h3>

    <div class="sal-panel__card">
      <span class="sal-panel__card-label">Total scrap (piezas)</span>
      <div class="sal-panel__comparacion">
        <div class="sal-panel__col">
          <span class="sal-panel__badge sal-panel__badge--a">A</span>
          <span class="sal-panel__total-valor">{{ formatearPiezas(totalScrapA) }}</span>
          <div v-if="totalRealA > 0" class="sal-panel__pct">
            <span class="sal-panel__pct-valor sal-panel__pct--a"
              >{{ formatearPct(porcentajeScrapA) }}%</span
            >
            <span class="sal-panel__pct-label">de fabricadas</span>
          </div>
          <span v-else class="sal-panel__sin-plan">sin plan</span>
        </div>

        <div class="sal-panel__divisor"></div>

        <div class="sal-panel__col">
          <span class="sal-panel__badge sal-panel__badge--b">B</span>
          <span class="sal-panel__total-valor">{{ formatearPiezas(totalScrapB) }}</span>
          <div v-if="totalRealB > 0" class="sal-panel__pct">
            <span class="sal-panel__pct-valor sal-panel__pct--b"
              >{{ formatearPct(porcentajeScrapB) }}%</span
            >
            <span class="sal-panel__pct-label">de fabricadas</span>
          </div>
          <span v-else class="sal-panel__sin-plan">sin plan</span>
        </div>
      </div>
    </div>
  </aside>
</template>

<script setup>
defineProps({
  totalScrapA: { type: Number, default: 0 },
  totalRealA: { type: Number, default: 0 },
  porcentajeScrapA: { type: Number, default: 0 },
  totalScrapB: { type: Number, default: 0 },
  totalRealB: { type: Number, default: 0 },
  porcentajeScrapB: { type: Number, default: 0 },
});

function formatearPiezas(v) {
  return new Intl.NumberFormat("es-MX", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(v || 0);
}
function formatearPct(v) {
  return new Intl.NumberFormat("es-MX", {
    minimumFractionDigits: 3,
    maximumFractionDigits: 3,
  }).format(v || 0);
}
</script>
